import { addActionBarItem } from '@vendure/admin-ui/core';
import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';

const SYNC_PRODUCTS_MUTATION = gql`
    mutation SyncProducts($productId: ID!) {
        syncProductsBySku(productId: $productId)
    }
`;

export default [
    addActionBarItem({
        id: 'sync-product-btn',
        locationId: 'product-detail',
        icon: 'refresh',
        label: 'Sincronizar Produto',
        onClick: async (event, context) => {
            const productId = context.route.snapshot.params.id;

            if (!productId) {
                context.notificationService.error('Produto não encontrado');
                return;
            }

            try {
                firstValueFrom(
                    context.dataService.mutate(SYNC_PRODUCTS_MUTATION, {
                        productId,
                    })
                );

                context.notificationService.success(
                    'Sincronização do produto iniciada com sucesso.'
                );
            } catch (error: any) {
                console.error('Erro na mutation SyncProducts:', error);
                context.notificationService.error(
                    'Erro ao sincronizar cliente: ' +
                        (error.message || 'Erro desconhecido')
                );
            }
        },
        requiresPermission: ['SyncProducts'],
    }),
];
